export const INVESTMENT_WRAPPERS = [
  'EIS - Taxed to CGT\n(under current rules)',
  'Note - Taxed to Income\n(under current rules)',
  'Certificate EMTN',
  'Warrant',
  'n/a',
] as const

export type InvestmentWrapper = (typeof INVESTMENT_WRAPPERS)[number]

export const INVESTMENT_WRAPPER_OPTIONS = INVESTMENT_WRAPPERS.map((i) => ({
  label: i,
  value: i,
}))
